export const EXTERNAL_LINK = "externalLink";
export const DOWNLOAD = "download";
export const LINK = "link";
export const VIDEO = "video";
